<template>
  <v-dialog v-model="dialogLocal" persistent max-width="950px">
    <v-card>
      <v-card-title class="d-flex align-center">
        Replicar Ticket
      </v-card-title>

      <v-card-text>
        <v-alert v-if="!item" type="warning" dense text>
          No hay ticket seleccionado.
        </v-alert>

        <template v-else>
          <div class="d-flex justify-end mb-3">
            <v-btn color="primary" @click="abrirDialogCrearReplica()">Crear copia</v-btn>
          </div>

          <v-data-table :headers="headersCopias" :items="copiasTicket" :loading="loadingCopias" item-key="idReplica" dense
            class="elevation-0">
            <template v-slot:item.reporto="{ item: r }">
              {{ fmt(r.reporto || r.Reporto) }}
            </template>

            <template v-slot:item.causa="{ item: r }">
              {{ pickTexto(r.otraCausa, r.causa, "SIN ESPECIFICAR") }}
            </template>

            <template v-slot:item.solucion="{ item: r }">
              {{ pickTexto(r.otraSolucion, r.solucion, "SIN ESPECIFICAR") }}
            </template>

            <template v-slot:item.personas="{ item: r }">
              <span v-if="Array.isArray(r.personas)">{{ r.personas.length }}</span>
              <span v-else>0</span>
            </template>

            <template v-slot:item.acciones="{ item: r }">
              <v-tooltip bottom color="black" class="white--text">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" small @click="verDetalles(r)">mdi-eye</v-icon>
                </template>
                <span class="white--text">Ver</span>
              </v-tooltip>

              <v-tooltip bottom color="black" class="white--text" v-if="false">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" small class="ml-2" @click="crearCopia(r)">
                    mdi-content-duplicate
                  </v-icon>
                </template>
                <span class="white--text">Crear copia desde esta</span>
              </v-tooltip>
            </template>

            <template v-slot:no-data>
              <div class="py-4 text-center">No hay copias registradas.</div>
            </template>
          </v-data-table>
        </template>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="error" @click="$emit('cerrarReplica')">
          Cerrar
        </v-btn>
      </v-card-actions>
    </v-card>

    <!-- Detalles (simple, autocontenidos) -->
    <v-dialog v-model="dialogDetalles" persistent max-width="520px">
      <v-card>
        <v-card-title class="d-flex align-center">
          Detalles de la Copia
          <v-spacer />
          <v-btn icon @click="cerrarDetalles">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-simple-table v-if="detalle">
            <tbody>
              <tr>
                <td class="font-weight-bold">IdReplica</td>
                <td>{{ detalle.idReplica || detalle.IdReplica }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Reportó</td>
                <td>{{ fmt(detalle.reporto || detalle.Reporto) }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Causa</td>
                <td>{{ pickTexto(detalle.otraCausa, detalle.causa, "SIN ESPECIFICAR") }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Subcausa</td>
                <td>{{ pickTexto(detalle.otraSubCausa || detalle.otraSubcausa, detalle.subcausa, "SIN ESPECIFICAR") }}
                </td>
              </tr>
              <tr>
                <td class="font-weight-bold">Solución</td>
                <td>{{ pickTexto(detalle.otraSolucion, detalle.solucion, "SIN ESPECIFICAR") }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Equipo</td>
                <td>{{ detalle.equipo || detalle.Equipo || "N/A" }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Comentarios</td>
                <td>{{ detalle.comentarios || detalle.Comentarios || "N/A" }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Personas</td>
                <td>
                  <div v-if="detalle.personas && detalle.personas.length">
                    <ul class="ma-0 pa-0" style="list-style-position: inside;">
                      <li v-for="(p, i) in detalle.personas" :key="'p-' + i">{{ p.nombre }}</li>
                    </ul>
                  </div>
                  <div v-else>N/A</div>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn text color="success" @click="cerrarDetalles">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog apra crear copia -->
    <v-dialog v-model="dialogCrearReplica" persistent max-width="500px">
      <v-card>
        <v-card-title>Crear copia del Ticket</v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <!-- RecordId (solo visual) -->
              <v-col cols="12" md="12" xl="12" class="py-0">
                <v-text-field label="RecordId" readonly v-model="replicaForm.recordID"></v-text-field>
              </v-col>

              <!-- Causa -->
              <v-col cols="12" class="py-0">
                <v-autocomplete v-model="replicaForm.idCausa" label="Causa del Ticket" :items="causasFiltradas"
                  :item-text="nombreCausa" item-value="idCausa" clearable :error-messages="errorCausa"
                  @focus="errorCausa = ''" @change="replicaForm.idSubCausa = null"></v-autocomplete>
              </v-col>

              <v-col cols="12" v-if="replicaForm.idCausa === 0" class="py-0">
                <v-text-field v-model="replicaForm.otraCausa" label="Indique Otra Causa" clearable
                  :error-messages="errorOtraCausa" @focus="errorOtraCausa = ''"></v-text-field>
              </v-col>

              <!-- SubCausa (si aplica) -->
              <v-col cols="12" class="py-0" v-if="replicaForm.idCausa">
                <v-autocomplete v-model="replicaForm.idSubCausa" label="SubCausa del Ticket (Opcional)"
                  :items="subcausasFiltradas" item-value="idSubCausa" :item-text="nombreSubCausa" clearable
                  :error-messages="errorSubCausa" @focus="errorSubCausa = ''"></v-autocomplete>
              </v-col>

              <!-- Solución -->
              <v-col cols="12" class="py-0" v-if="replicaForm.idCausa > 0">
                <v-autocomplete v-model="replicaForm.idSolucion" label="Solución del Ticket"
                  :items="solucionesFiltradasReplica" :item-text="nombreSolucion" item-value="idSolucion" clearable
                  :error-messages="errorSolucion" @focus="errorSolucion = ''"></v-autocomplete>
              </v-col>

              <!-- Código de falla -->
              <v-col cols="12">
                <v-autocomplete v-model="replicaForm.factorBase.idFactor" :items="catalogoFactores" item-text="nombre"
                  item-value="idFactor" :label="'Codigo de Falla (Obligatorio)'" :error-messages="errorCodigoFalla"
                  @focus="errorCodigoFalla = ''"
                  @change="replicaForm.factorBase.idSubFactor = null; errorModoFalla = ''"></v-autocomplete>
              </v-col>

              <!-- Modo de falla -->
              <v-col cols="12">
                <v-autocomplete v-model="replicaForm.factorBase.idSubFactor" :items="subFactoresFiltradosReplica"
                  item-text="nombre" item-value="idSubFactor" label="Modo de falla (Obligatorio)"
                  :disabled="!replicaForm.factorBase.idFactor" :error-messages="errorModoFalla"
                  @focus="errorModoFalla = ''"></v-autocomplete>
              </v-col>

              <!-- Personas (solo si tu réplica realmente las va a guardar/mandar) -->
              <v-col cols="12" class="py-0">
                <v-autocomplete v-model="replicaForm.idsPersonas" :items="personasFiltradasReplica"
                  item-value="idPersona" :item-text="nompreOperador" label="Personas" multiple chips deletable-chips
                  :error-messages="errorPersonas" @focus="errorPersonas = ''"></v-autocomplete>
              </v-col>


              <!-- Equipo (solo mantenimiento, misma condición estética) -->
              <v-col cols="12" class="py-0"
                v-if="item && item.area != null && (item.departamento || '').toUpperCase() == 'MANTENIMIENTO'">
                <v-autocomplete v-model="replicaForm.idEquipo" :items="equiposFiltradosReplica" item-value="idEquipo"
                  :item-text="nombreEquipo" label="Equipo" append-outer-icon="mdi-qrcode-scan"
                  :error-messages="errorEquipo" @focus="errorEquipo = ''"
                  @click:append-outer="showDialogScanner"></v-autocomplete>
              </v-col>

              <!-- NumOperacion -->
              <v-col cols="12" class="py-0">
                <v-row class="ma-0 pa-0">
                  <v-col cols="3" />
                  <v-col cols="6" class="text-center">
                    <div>Número de Operación</div>
                    <v-otp-input v-model="replicaForm.numOperacion" type="number" length="3"></v-otp-input>
                  </v-col>
                  <v-col cols="3" />
                </v-row>
              </v-col>

              <!-- Comentarios -->
              <v-col cols="12" class="py-0">
                <v-textarea v-model="replicaForm.comentarios" label="Comentarios" auto-grow rows="3" clearable
                  outlined></v-textarea>
              </v-col>
            </v-row>
          </v-container>

          <!-- Errores -->
          <div v-if="(errorCrearReplica && errorCrearReplica.length) || (erroresReplica && erroresReplica.length)"
            class="mt-2">
            <v-alert type="error" outlined dense>
              <div class="font-weight-medium mb-2">Corrige lo siguiente:</div>

              <v-list dense class="py-0">
                <v-list-item v-if="errorCrearReplica" class="px-0">
                  <v-list-item-content class="py-0">
                    <v-list-item-title class="body-2">• {{ errorCrearReplica }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item v-for="(e, i) in (erroresReplica || [])" :key="'er-' + i" class="px-0">
                  <v-list-item-content class="py-0">
                    <v-list-item-title class="body-2">• {{ e }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-alert>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="success" :disabled="saving" :loading="saving" @click="dialogCrearReplica = false">
            Cerrar
          </v-btn>
          <v-btn text color="error" :disabled="saving" :loading="saving" @click="guardarReplica()">
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
import axios from 'axios';


const pickTexto = (preferido, fallback, defecto) =>
  (preferido != null && String(preferido).trim() !== "")
    ? preferido
    : ((fallback != null && String(fallback).trim() !== "") ? fallback : defecto);

const fmtDateTime = (val) => {
  if (!val) return "N/D";
  if (typeof val === "string") return val;
  try {
    const d = new Date(val);
    if (Number.isNaN(d.getTime())) return String(val);
    const pad = (n) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
  } catch (e) {
    return String(val);
  }
};

export default {
  props: {
    value: { type: Boolean, required: true },
    item: { type: Object, required: false, default: null },
    catalogoCausas: { type: Array, default: () => [] },
    catalogoSubcausas: { type: Array, default: () => [] },
    catalogoSoluciones: { type: Array, default: () => [] },
    catalogoFactores: { type: Array, default: () => [] },
    catalogoSubfactores: { type: Array, default: () => [] },
    catalogoPersonas: { type: Array, default: () => [] },
    catalogoEquipos: { type: Array, default: () => [] },

    nombreCausa: { type: Function, default: null },
    nombreSubCausa: { type: Function, default: null },
    nombreSolucion: { type: Function, default: null },
    nompreOperador: { type: Function, default: null },
    nombreEquipo: { type: Function, default: null },

    onFiltroSubcausas: { type: Function, default: null },
  },
  data() {
    return {
      copias: [],
      loadingCopias: false,
      saving: false,
      errorMsg: "",
      dialogDetalles: false,
      detalle: null,
      copiasTicket: [],
      headersCopias: [
        { text: "Id", value: "idReplica", width: 80 },
        { text: "Reportó", value: "reporto" },
        { text: "Causa", value: "causa" },
        { text: "Solución", value: "solucion" },
        { text: "Personas", value: "personas", align: "center", width: 90 },
        { text: "Acciones", value: "acciones", sortable: false, align: "center", width: 140 },
      ],

      dialogCrearReplica: false,
      originalSnapshot: null,
      errorCrearReplica: "",

      replicaForm: {
        recordID: 0,
        recordIdOrigen: null,
        idCausa: null,
        idSubCausa: null,
        idSolucion: null,
        otraCausa: null,
        otraSubCausa: null,
        otraSolucion: null,
        comentarios: null,
        numOperacion: null,
        idEquipo: null,
        factores: [],
        factorBase: {
          idFactor: null,
          idSubFactor: null,
        },
        idsPersonas: [],
      },
      replicaFormDefault: {
        recordID: 0,
        recordIdOrigen: null,

        idCausa: null,
        idSubCausa: null,
        idSolucion: null,

        otraCausa: null,
        otraSubCausa: null,
        otraSolucion: null,

        comentarios: null,
        numOperacion: null,

        idEquipo: null,

        factores: [],
        factorBase: {
          idFactor: null,
          idSubFactor: null,
        },
        idsPersonas: [],
      },
      // errores generales del dialog
      erroresReplica: [],
      errorCrearReplica: "",

      // errores por campo (los usa el template y validateReplica)
      errorCausa: "",
      errorSolucion: "",
      errorOtraCausa: "",
      errorPersonas: "",
      errorEquipo: "",
      errorCodigoFalla: "",
      errorModoFalla: "",
    };
  },
  computed: {
    dialogLocal: {
      get() { return this.value; },
      set(v) { this.$emit("input", v); },
    },
    cualquierSolucion() {
      if (this.replicaForm.idCausa <= 0) return false;
      var e = this.catalogoCausas.find(x => x.idCausa == this.replicaForm.idCausa);
      if (typeof e == 'undefined' || e == null) return false;
      return e.abierto;
    },
    causasFiltradas() {
      if (!this.item || !this.item.recordID) return [];

      const area = this.item.area ? String(this.item.area).toUpperCase() : null;
      const dep = this.item.departamento ? String(this.item.departamento).toUpperCase() : null;

      return (this.catalogoCausas || []).filter(c =>
        c.idCausa == 0 ||
        (
          (c.area == null ? null : String(c.area).toUpperCase()) === area &&
          (c.departamento == null ? null : String(c.departamento).toUpperCase()) === dep
        )
      );
    },
    subcausasFiltradas() {
      const idCausa = Number(this.replicaForm?.idCausa ?? 0);
      if (!idCausa || idCausa <= 0) return [];

      const lista = (this.catalogoSubcausas || []).filter(sc => Number(sc.idCausa) === idCausa);

      return [
        ...lista,
        { idSubCausa: 0, subcausa: "Otra SubCausa", codigo: null },
      ];
    },
    solucionesFiltradasReplica() {
      const f = this.replicaForm || {};
      const idCausa = Number(f.idCausa ?? 0);
      const idSubCausa = Number(f.idSubCausa ?? 0);

      if (!this.item || !this.item.recordID || idCausa <= 0) return [];

      const area = String(this.item.area ?? "").trim().toUpperCase();
      const departamento = String(this.item.departamento ?? "").trim().toUpperCase();

      const lista = (this.catalogoSoluciones || []);

      if (this.cualquierSolucion) {
        return lista.filter(s =>
          s.abierto === true &&
          String(s.area ?? "").trim().toUpperCase() === area &&
          String(s.departamento ?? "").trim().toUpperCase() === departamento
        );
      }

      if (idSubCausa > 0) {
        return lista.filter(s =>
          (Number(s.idCausa) === idCausa && Number(s.idSubCausa) === idSubCausa) ||
          Number(s.idSolucion) === 0
        );
      }

      return lista.filter(s =>
        (Number(s.idCausa) === idCausa && Number(s.idSubCausa) === 0) ||
        Number(s.idSolucion) === 0
      );
    },
    factoresFiltradosReplica() {
      if (!this.replicaForm || !this.replicaForm.recordID) return [];

      const dep = String(this.item.departamento || "").trim().toUpperCase();

      const f = (this.catalogoFactores || []).find(x =>
        String(x.departamento || "").trim().toUpperCase() === dep
      );

      if (!f) return this.catalogoFactores;
      return Array.isArray(f.factores) ? f.factores : (Array.isArray(f.items) ? f.items : []);
    },
    subFactoresFiltradosReplica() {
      const idFactor = Number(this.replicaForm?.factorBase?.idFactor ?? 0);
      if (!idFactor) return [];

      const factor = (this.catalogoFactores || []).find(f => Number(f.idFactor) === idFactor);
      return factor && Array.isArray(factor.subFactores) ? factor.subFactores : [];
    },
    personasFiltradasReplica() {
      if (!this.replicaForm || !this.replicaForm.recordID) return [];

      const dep = String(this.item.departamento || "").trim().toUpperCase();
      if (!dep) return this.catalogoPersonas || [];

      return (this.catalogoPersonas || []).filter(p =>
        String(p.departamentoNombre || "").trim().toUpperCase() === dep
      );
    },
  },
  watch: {
    dialogLocal: {
      immediate: true,
      async handler(v) {
        if (v) this.getReplcias();
        if (!v) this.limpiar();
      },
    },
  },
  methods: {
    pickTexto,
    fmt(val) { return fmtDateTime(val); },

    limpiar() {
      this.copias = [];
      this.loadingCopias = false;
      this.saving = false;
      this.errorMsg = "";
      this.dialogDetalles = false;
      this.detalle = null;
    },

    cerrar() {
      this.dialogLocal = false;
    },

    getReplcias() {
      const idTicket = (this.item && this.item.recordID) ? this.item.recordID : 0;

      if (!idTicket || idTicket <= 0) {
        console.log("IdTicket inválido");
        return;
      }

      this.loadingCopias = true;     // si ya tienes flag
      this.copiasTicket = [];        // arreglo donde guardarás las réplicas

      axios
        .get("/CausaSolucionRecords/ListarReplicasTicket", {
          params: { IdTicket: idTicket },
        })
        .then((response) => {
          // el EP regresa List<CausaSolucionRecordReplicaListViewModel>
          this.copiasTicket = Array.isArray(response.data) ? response.data : [];
        })
        .catch((error) => console.log(error))
        .finally(() => {
          this.loadingCopias = false;
        });
    },

    abrirDialogCrearReplica() {
      if (!this.item) return;

      const ids = Array.isArray(this.item?.personas)
        ? this.item.personas.map(p => p.idPersona).filter(x => !!x)
        : [];
      const f0 = Array.isArray(this.item?.factores) ? this.item.factores[0] : null;

      this.replicaForm = {
        recordID: this.item.recordID,
        idCausa: this.item.idCausa ?? 0,
        idSubcausa: this.item.idSubCausa ?? this.item.idSubcausa ?? 0,
        idSolucion: this.item.idSolucion ?? 0,
        otraCausa: this.item.otraCausa ?? null,
        otraSubCausa: this.item.otraSubCausa ?? this.item.otraSubcausa ?? null,
        otraSolucion: this.item.otraSolucion ?? null,
        comentarios: this.item.comentarios ?? null,
        numOperacion: this.item.numOperacion ?? null,
        factores: Array.isArray(this.item.factores) ? this.item.factores : [],
        factorBase: {
          idFactor: f0?.idFactor ?? null,
          idSubFactor: f0?.idSubFactor ?? null,
        },
        idEquipo: this.item.idEquipo ?? null,
        idsPersonas: ids,
      };
      this.errorCrearReplica = "";
      this.dialogCrearReplica = true;
    },

    async guardarReplica() {
      if (!this.validateReplica()) return;

      this.errorCrearReplica = "";

      if (this._esIgualAlOriginal()) {
        this.errorCrearReplica = "No puedes guardar una copia idéntica al original. Cambia al menos un campo.";
        return;
      }

      const payload = {
        recordId: this.replicaForm.recordID,                 // el ticket al que pertenece la copia
        recordIdOrigen: this.item?.recordID ?? null,         // referente (original)
        idCausa: Number(this.replicaForm.idCausa ?? 0),
        idSubcausa: Number(this.replicaForm.idSubCausa ?? 0),
        idSolucion: Number(this.replicaForm.idSolucion ?? 0),
        otraCausa: this.replicaForm.otraCausa ?? null,
        otraSubCausa: this.replicaForm.otraSubCausa ?? null,
        otraSolucion: this.replicaForm.otraSolucion ?? null,
        comentarios: this.replicaForm.comentarios ?? null,
        numOperacion: this.replicaForm.numOperacion ?? null,
        factores: this.replicaForm.factores ?? null,
        idEquipo: this.replicaForm.idEquipo ?? null,
        idsPersonas: Array.isArray(this.replicaForm.idsPersonas) ? this.replicaForm.idsPersonas : [],
      };

      this.saving = true;
      try {
        await axios.post("/CausaSolucionRecords/CrearReplica", payload);
        this.dialogCrearReplica = false;
        await this.getReplcias();
      } catch (e) {
        this.errorCrearReplica = e?.response?.data?.message || e?.message || "Error al crear copia.";
      } finally {
        this.saving = false;
      }
    },

    validateReplica() {
      this.erroresReplica = [];
      this.errorCausa = "";
      this.errorSolucion = "";
      this.errorOtraCausa = "";
      this.errorPersonas = "";
      this.errorEquipo = "";
      this.errorCodigoFalla = "";
      this.errorModoFalla = "";
      this.errorCrearReplica = "";

      const f = this.replicaForm || {};
      const item = this.item || {};

      const idCausa = Number(f.idCausa ?? 0);
      const idSubCausa = Number(f.idSubCausa ?? 0);
      const idSolucion = Number(f.idSolucion ?? 0);

      const idFactor = Number(f?.factorBase?.idFactor ?? 0);
      const idSubFactor = Number(f?.factorBase?.idSubFactor ?? 0);

      // 1) Causa obligatoria
      if (f.idCausa == null) {
        this.errorCausa = "Debe Seleccionar una Causa";
        this.erroresReplica.push(this.errorCausa);
      }

      // 2) Si causa = 0, otraCausa obligatoria
      if (idCausa === 0) {
        const otra = (f.otraCausa ?? "").toString().trim();
        if (!otra || otra.length <= 1) {
          this.errorOtraCausa = "Debe de Indicar una Causa";
          this.erroresReplica.push(this.errorOtraCausa);
        }
      }

      // 3) Solución obligatoria si idCausa > 0
      // (tu UI deja subcausa opcional; solución sigue siendo obligatoria)
      if (idCausa > 0 && (f.idSolucion == null || idSolucion <= 0)) {
        this.errorSolucion = "Debe Seleccionar una Solución";
        this.erroresReplica.push(this.errorSolucion);
      }

      // 4) Código de falla / modo de falla obligatorios
      if (!idFactor) {
        this.errorCodigoFalla = "Debe Seleccionar un Código de Falla";
        this.erroresReplica.push(this.errorCodigoFalla);
      }
      if (!idSubFactor) {
        this.errorModoFalla = "Debe Seleccionar un Modo de Falla";
        this.erroresReplica.push(this.errorModoFalla);
      }

      // 5) Personas (si tu pantalla las requiere)
      // Nota: el back de réplica NO guarda personas, pero si las mandas al endpoint de creación, valida aquí.
      const personasReq = (this.personasFiltradasReplica && this.personasFiltradasReplica.length > 0);
      if (personasReq && (!Array.isArray(f.idsPersonas) || f.idsPersonas.length === 0)) {
        this.errorPersonas = "Debe Indicar Mínimo una Persona";
        this.erroresReplica.push(this.errorPersonas);
      }

      // 6) Equipo obligatorio si mantenimiento
      if (String(item.departamento || "").trim().toUpperCase() === "MANTENIMIENTO") {
        const idEquipo = Number(f.idEquipo ?? 0);
        if (!idEquipo) {
          this.errorEquipo = "Debe de Indicar un Equipo";
          this.erroresReplica.push(this.errorEquipo);
        }
      }

      // 7) No permitir guardar exactamente lo mismo que el ticket base
      // (compara campos clave; si no cambió nada, bloquea)
      const same =
        Number(item.idCausa ?? 0) === idCausa &&
        Number(item.idSubCausa ?? item.idSubcausa ?? 0) === idSubCausa &&
        Number(item.idSolucion ?? 0) === idSolucion &&
        String(item.otraCausa ?? "") === String(f.otraCausa ?? "") &&
        String(item.otraSubCausa ?? item.otraSubcausa ?? "") === String(f.otraSubCausa ?? "") &&
        String(item.otraSolucion ?? "") === String(f.otraSolucion ?? "") &&
        String(item.comentarios ?? "") === String(f.comentarios ?? "") &&
        String(item.numOperacion ?? "") === String(f.numOperacion ?? "") &&
        Number(item.idEquipo ?? 0) === Number(f.idEquipo ?? 0) &&
        // Factor base (si tu item trae factores[])
        Number(item?.factores?.[0]?.idFactor ?? 0) === idFactor &&
        Number(item?.factores?.[0]?.idSubFactor ?? 0) === idSubFactor;

      if (same) {
        this.errorCrearReplica = "No puedes guardar una copia idéntica al ticket original.";
        this.erroresReplica.push(this.errorCrearReplica);
      }

      return this.erroresReplica.length === 0;
    },
    _esIgualAlOriginal() {
      const normStr = (v) => {
        if (v === undefined || v === null) return "";
        return String(v).trim().toUpperCase();
      };

      const normNum = (v, def = 0) => {
        const n = Number(v);
        return Number.isFinite(n) ? n : def;
      };

      const normArrNums = (arr) => {
        if (!Array.isArray(arr)) return [];
        return arr
          .map((x) => normNum(x))
          .filter((x) => x > 0)
          .sort((a, b) => a - b);
      };

      const normFactores = (f) => {
        // Tu form usa factores como objeto { idFactor, idSubFactor } (según tu dialog)
        // item.factores viene como [] (en tu ejemplo). Si es [] lo tratamos como vacío.
        if (!f) return { idFactor: 0, idSubFactor: 0 };

        if (Array.isArray(f)) {
          // si por alguna razón llega array, intenta tomar el primero
          const first = f[0] || {};
          return {
            idFactor: normNum(first.idFactor ?? first.IdFactor ?? 0),
            idSubFactor: normNum(first.idSubFactor ?? first.IdSubFactor ?? 0),
          };
        }

        return {
          idFactor: normNum(f.idFactor ?? f.IdFactor ?? 0),
          idSubFactor: normNum(f.idSubFactor ?? f.IdSubFactor ?? 0),
        };
      };

      const o = this.item || {};
      const f = this.replicaForm || {};

      // Original
      const oIdCausa = normNum(o.idCausa ?? 0);
      const oIdSub = normNum(o.idSubCausa ?? o.idSubcausa ?? 0);
      const oIdSol = normNum(o.idSolucion ?? 0);
      const oOtraCausa = normStr(o.otraCausa);
      const oOtraSub = normStr(o.otraSubCausa ?? o.otraSubcausa);
      const oOtraSol = normStr(o.otraSolucion);
      const oComentarios = normStr(o.comentarios);
      const oNumOp = normStr(o.numOperacion);
      const oIdEquipo = normNum(o.idEquipo ?? 0);
      const oFact = normFactores(o.factores);
      const oIdsPersonas = normArrNums((o.personas || []).map((p) => p.idPersona));

      // Form
      const fIdCausa = normNum(f.idCausa ?? 0);
      const fIdSub = normNum(f.idSubCausa ?? f.idSubcausa ?? 0);
      const fIdSol = normNum(f.idSolucion ?? 0);
      const fOtraCausa = normStr(f.otraCausa);
      const fOtraSub = normStr(f.otraSubCausa ?? f.otraSubcausa);
      const fOtraSol = normStr(f.otraSolucion);
      const fComentarios = normStr(f.comentarios);
      const fNumOp = normStr(f.numOperacion);
      const fIdEquipo = normNum(f.idEquipo ?? 0);
      const fFact = normFactores(f.factores);
      const fIdsPersonas = normArrNums(f.idsPersonas);

      // Comparación (si TODO coincide => es idéntica)
      if (oIdCausa !== fIdCausa) return false;
      if (oIdSub !== fIdSub) return false;
      if (oIdSol !== fIdSol) return false;

      if (oOtraCausa !== fOtraCausa) return false;
      if (oOtraSub !== fOtraSub) return false;
      if (oOtraSol !== fOtraSol) return false;

      if (oComentarios !== fComentarios) return false;
      if (oNumOp !== fNumOp) return false;

      if (oIdEquipo !== fIdEquipo) return false;

      if (oFact.idFactor !== fFact.idFactor) return false;
      if (oFact.idSubFactor !== fFact.idSubFactor) return false;

      if (oIdsPersonas.length !== fIdsPersonas.length) return false;
      for (let i = 0; i < oIdsPersonas.length; i++) {
        if (oIdsPersonas[i] !== fIdsPersonas[i]) return false;
      }

      return true;
    },



    verDetalles(replica) {
      this.detalle = replica;
      this.dialogDetalles = true;
    },
    cerrarDetalles() {
      this.dialogDetalles = false;
      this.detalle = null;
    },
  },
};
</script>